import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { sendCommandFlex8 } from "../../../API/AcionamentoFlex8";
import { getLuzesStatusFlex35, statusDasLuzesFlex35, getLuzesStatusFlex8, statusDasLuzesFlex8} from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo04: React.createRef(),
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo12: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo15: React.createRef(),
    grupo16: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
    grupo19: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
    grupo22: React.createRef(),
    grupo23: React.createRef(),
    grupo24: React.createRef(),
    grupo25: React.createRef(),
    grupo26: React.createRef(),
    grupo27: React.createRef(),
    grupo28: React.createRef(),
    grupo29: React.createRef(),
    grupo30: React.createRef(),
    grupo31: React.createRef(),
    grupo32: React.createRef(),
    grupo42: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo04: false,
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo12: false,
    grupo13: false,
    grupo14: false,
    grupo15: false,
    grupo16: false,
    grupo17: false,
    grupo18: false,
    grupo19: false,
    grupo20: false,
    grupo21: false,
    grupo22: false,
    grupo23: false,
    grupo24: false,
    grupo25: false,
    grupo26: false,
    grupo27: false,
    grupo28: false,
    grupo29: false,
    grupo30: false,
    grupo31: false,
    grupo32: false,
    grupo42: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      await getLuzesStatusFlex8();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes Flex35:", statusDasLuzesFlex35);
      console.log("Status das luzes Flex8:", statusDasLuzesFlex8);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8200);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo01: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo02: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo03: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo04: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo08: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo09: statusDasLuzesFlex35.includes("1I10") && !statusDasLuzesFlex35.includes("1I00"),
      grupo10: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo12: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
      grupo13: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo14: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo15: statusDasLuzesFlex35.includes("1O10") && !statusDasLuzesFlex35.includes("1O00"),
      grupo16: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo17: statusDasLuzesFlex35.includes("1Q10") && !statusDasLuzesFlex35.includes("1Q00"),
      grupo18: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo19: statusDasLuzesFlex35.includes("1S10") && !statusDasLuzesFlex35.includes("1S00"),
      grupo20: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
      grupo21: statusDasLuzesFlex35.includes("1U10") && !statusDasLuzesFlex35.includes("1U00"),
      grupo22: statusDasLuzesFlex35.includes("1V10") && !statusDasLuzesFlex35.includes("1V00"),
      grupo23: statusDasLuzesFlex35.includes("1W10") && !statusDasLuzesFlex35.includes("1W00"),
      grupo24: statusDasLuzesFlex35.includes("1X10") && !statusDasLuzesFlex35.includes("1X00"),
      grupo25: statusDasLuzesFlex35.includes("1Y10") && !statusDasLuzesFlex35.includes("1Y00"),
      grupo26: statusDasLuzesFlex35.includes("1Z10") && !statusDasLuzesFlex35.includes("1Z00"),
      grupo27: statusDasLuzesFlex35.includes("1a10") && !statusDasLuzesFlex35.includes("1a00"),
      grupo28: statusDasLuzesFlex35.includes("1b10") && !statusDasLuzesFlex35.includes("1b00"),
      grupo29: statusDasLuzesFlex35.includes("1c10") && !statusDasLuzesFlex35.includes("1c00"),
      grupo30: statusDasLuzesFlex35.includes("1d10") && !statusDasLuzesFlex35.includes("1d00"),
      grupo31: statusDasLuzesFlex35.includes("1e10") && !statusDasLuzesFlex35.includes("1e00"),
      grupo32: statusDasLuzesFlex35.includes("1f10") && !statusDasLuzesFlex35.includes("1f00"),
      grupo42: statusDasLuzesFlex8[6] && statusDasLuzesFlex8[6].includes("ON")
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (
    <div id="BotoesMobile">

      <h2 id='Title-botoes-Mobile'>Térreo</h2>
      {/* Botões para clicar em cima da legenda */}
      <div className="campoBotoesAcionamento-terreo-mobile">

        <h3 id='Topic-botoes-Mobile'>San Marino</h3>

        <div
          ref={groupRefs.current.grupo01}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo01', !imageStates.grupo01);
            sendCommandFlex35('Circulação Serviço 1 da torre San Marino', imageStates.grupo01 ? '1A00' : '1A10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo01 ? 'Highlighted' : ''}`}>01</p>
          <p className="textBar">Circulação Serviço 1</p>
        </div>

        <div
          ref={groupRefs.current.grupo02}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo02', !imageStates.grupo02);
            sendCommandFlex35('Circulação Serviço 2 da torre San Marino', imageStates.grupo02 ? '1B00' : '1B10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo02 ? 'Highlighted' : ''}`}>02</p>
          <p className="textBar">Circulação Serviço 2</p>
        </div>

        <div
          ref={groupRefs.current.grupo03}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo03', !imageStates.grupo03);
            sendCommandFlex35('Parede Hall Social da torre San Marino', imageStates.grupo03 ? '1C00' : '1C10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo03 ? 'Highlighted' : ''}`}>03</p>
          <p className="textBar">Parede Hall Social</p>
        </div>

        <div
          ref={groupRefs.current.grupo04}
          id="clickable-element-mobile-san-marino"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo04', !imageStates.grupo04);
            sendCommandFlex35('Pendente hall Social da torre San Marino', imageStates.grupo04 ? '1D00' : '1D10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo04 ? 'Highlighted' : ''}`}>04</p>
          <p className="textBar">Pendente hall Social</p>
        </div>

        <h3 id='Topic-botoes-Mobile'>Positano</h3>

        <div
          ref={groupRefs.current.grupo08}
          id="clickable-element-mobile-positano"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo08', !imageStates.grupo08);
            sendCommandFlex35('Parede Hall Social da torre Positano', imageStates.grupo08 ? '1H00' : '1H10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo08 ? 'Highlighted' : ''}`}>08</p>
          <p className="textBar">Parede Hall Social</p>
        </div>

        <div
          ref={groupRefs.current.grupo09}
          id="clickable-element-mobile-positano"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo09', !imageStates.grupo09);
            sendCommandFlex35('Circulação Serviço da torre Positano', imageStates.grupo09 ? '1I00' : '1I10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo09 ? 'Highlighted' : ''}`}>09</p>
          <p className="textBar">Circulação Serviço</p>
        </div>

        <div
          ref={groupRefs.current.grupo10}
          id="clickable-element-mobile-positano"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo10', !imageStates.grupo10);
            sendCommandFlex35('Varanda Térreo e Intermediário da torre Positano', imageStates.grupo10 ? '1J00' : '1J10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo10 ? 'Highlighted' : ''}`}>10</p>
          <p className="textBar">Varanda térreo</p>
        </div>

        <h3 id='Topic-botoes-Mobile'>Outros</h3>

        <div
          ref={groupRefs.current.grupo12}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo12', !imageStates.grupo12);
            sendCommandFlex35('Jardim 1 da entrada', imageStates.grupo12 ? '1L00' : '1L10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo12 ? 'Highlighted' : ''}`}>12</p>
          <p className="textBar">Jardim 1 entrada</p>
        </div>
        <div
          ref={groupRefs.current.grupo13}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo13', !imageStates.grupo13);
            sendCommandFlex35('Jardim 2 entrada', imageStates.grupo13 ? '1M00' : '1M10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo13 ? 'Highlighted' : ''}`}>13</p>
          <p className="textBar">Jardim 2 entrada</p>
        </div>
        <div
          ref={groupRefs.current.grupo14}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo14', !imageStates.grupo14);
            sendCommandFlex35('Escadaria da entrada', imageStates.grupo14 ? '1N00' : '1N10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo14 ? 'Highlighted' : ''}`}>14</p>
          <p className="textBar">Escadaria da entrada</p>
        </div>
        <div
          ref={groupRefs.current.grupo15}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo15', !imageStates.grupo15);
            sendCommandFlex35('Poste Rua 1', imageStates.grupo15 ? '1O00' : '1O10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo15 ? 'Highlighted' : ''}`}>15</p>
          <p className="textBar">Poste Rua 1</p>
        </div>
        <div
          ref={groupRefs.current.grupo16}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo16', !imageStates.grupo16);
            sendCommandFlex35('Poste Rua 2', imageStates.grupo16 ? '1P00' : '1P10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo16 ? 'Highlighted' : ''}`}>16</p>
          <p className="textBar">Poste Rua 2</p>
        </div>
        <div
          ref={groupRefs.current.grupo17}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo17', !imageStates.grupo17);
            sendCommandFlex35('Varanda Térreo', imageStates.grupo17 ? '1Q00' : '1Q10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo17 ? 'Highlighted' : ''}`}>17</p>
          <p className="textBar">Floreira Térreo 1</p>
        </div>
        <div
          ref={groupRefs.current.grupo18}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo18', !imageStates.grupo18);
            sendCommandFlex35('Floreira Térreo 2', imageStates.grupo18 ? '1R00' : '1R10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo18 ? 'Highlighted' : ''}`}>18</p>
          <p className="textBar">Floreira Térreo 2</p>
        </div>
        <div
          ref={groupRefs.current.grupo19}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo19', !imageStates.grupo19);
            sendCommandFlex35('Floreira Piscina 1', imageStates.grupo19 ? '1S00' : '1S10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo19 ? 'Highlighted' : ''}`}>19</p>
          <p className="textBar">Floreira Piscina 1</p>
        </div>
        {/*<div
          ref={groupRefs.current.grupo20}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo20', !imageStates.grupo20);
            sendCommandFlex35('Circulação Serviço', imageStates.grupo20 ? '1T00' : '1T10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo20 ? 'Highlighted' : ''}`}>20</p>
          <p className="textBar">Circulação Serviço</p>
        </div>*/}
        <div
          ref={groupRefs.current.grupo21}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo21', !imageStates.grupo21);
            sendCommandFlex35('Floreira interna da Piscina', imageStates.grupo21 ? '1U00' : '1U10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo21 ? 'Highlighted' : ''}`}>21</p>
          <p className="textBar">Floreira interna Piscina</p>
        </div>
        <div
          ref={groupRefs.current.grupo22}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo22', !imageStates.grupo22);
            sendCommandFlex35('Piscina', imageStates.grupo22 ? '1V00' : '1V10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo22 ? 'Highlighted' : ''}`}>22</p>
          <p className="textBar">Piscina</p>
        </div>
        <div
          ref={groupRefs.current.grupo23}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo23', !imageStates.grupo23);
            sendCommandFlex35('Perfil Muro piscina', imageStates.grupo23 ? '1W00' : '1W10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo23 ? 'Highlighted' : ''}`}>23</p>
          <p className="textBar">Perfil Muro piscina</p>
        </div>
        <div
          ref={groupRefs.current.grupo24}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo24', !imageStates.grupo24);
            sendCommandFlex35('Postes Piscina', imageStates.grupo24 ? '1X00' : '1X10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo24 ? 'Highlighted' : ''}`}>24</p>
          <p className="textBar">Varanda térreo</p>
        </div>
        {/*<div
          ref={groupRefs.current.grupo25}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo25', !imageStates.grupo25);
            sendCommandFlex35('Parede Hall Social', imageStates.grupo25 ? '1Y00' : '1Y10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo25 ? 'Highlighted' : ''}`}>25</p>
          <p className="textBar">Parede Hall Social</p>
        </div> */}
        <div
          ref={groupRefs.current.grupo26}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo26', !imageStates.grupo26);
            sendCommandFlex35('Floreira Piscina 3', imageStates.grupo26 ? '1Z00' : '1Z10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo26 ? 'Highlighted' : ''}`}>26</p>
          <p className="textBar">Floreira Piscina 3</p>
        </div>
        <div
          ref={groupRefs.current.grupo27}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo27', !imageStates.grupo27);
            sendCommandFlex35('Floreira Piscina 4', imageStates.grupo27 ? '1[00' : '1[10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo27 ? 'Highlighted' : ''}`}>27</p>
          <p className="textBar">Floreira Piscina 4</p>
        </div>
        <div
          ref={groupRefs.current.grupo28}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo28', !imageStates.grupo28);
            sendCommandFlex35('Floreira Quadra 1', imageStates.grupo28 ? '1\\00' : '1\\10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo28 ? 'Highlighted' : ''}`}>28</p>
          <p className="textBar">Floreira Quadra 1</p>
        </div>
        <div
          ref={groupRefs.current.grupo29}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo29', !imageStates.grupo29);
            sendCommandFlex35('Floreira Quadra 2', imageStates.grupo29 ? '1]00' : '1]10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo29 ? 'Highlighted' : ''}`}>29</p>
          <p className="textBar">Floreira Quadra 2</p>
        </div>
        <div
          ref={groupRefs.current.grupo30}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo30', !imageStates.grupo30);
            sendCommandFlex35('Pergolado', imageStates.grupo30 ? '1^00' : '1^10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo30 ? 'Highlighted' : ''}`}>30</p>
          <p className="textBar">Pergolado</p>
        </div>
        <div
          ref={groupRefs.current.grupo31}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo31', !imageStates.grupo31);
            sendCommandFlex35('Quadra 1', imageStates.grupo31 ? '1_00' : '1_10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo31 ? 'Highlighted' : ''}`}>31</p>
          <p className="textBar">Quadra 1</p>
        </div>
        <div
          ref={groupRefs.current.grupo32}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo32', !imageStates.grupo32);
            sendCommandFlex35('Quadra 2', imageStates.grupo32 ? '1`00' : '1`10');
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo32 ? 'Highlighted' : ''}`}>32</p>
          <p className="textBar">Quadra 2</p>
        </div>
        <div
          ref={groupRefs.current.grupo42}
          id="clickable-element-mobile-outros"
          className="clickable-element-mobile"
          onClick={() => {
            handleToggleLightGroup('grupo42', !imageStates.grupo42);
            sendCommandFlex8('Perfil Muro Fitness', imageStates.grupo42 ? {idx: "7", status: "OFF"} : {idx: "7", status: "ON"});
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo42 ? 'Highlighted' : ''}`}>42</p>
          <p className="textBar">Perfil Muro Fitness</p>
        </div>
      </div>
    </div>
  );
}

export default BotoesMobile;